<template>
  <div>
    <bar-chart v-if="type == 'bar'" ref="chart" autoresize></bar-chart>
    <line-chart v-if="type == 'line'" ref="chart" autoresize></line-chart>
  </div>
</template>

<style>
  canvas {
    height: 120px!important;
  }
</style>

<script>
import { Bar, Line } from 'vue-chartjs'

export default {
  props: {
    labels: {type: Array, default: ['A', 'B']},
    data: {type: Array, default: [50, 50]},
    format: {type: String, default: '0,000'},
    type: {type: String, default: 'bar'},
    tooltip_label_fn: {type: Function, default: undefined},
  },
  components: {
    'bar-chart': Bar,
    'line-chart': Line,
  },
  data() {
    return {
      trans: trans,
      numeral: numeral,
    }
  },
  methods: {
    render() {
      if (this.data == null) return

      let backgroundColors = _.map(this.data, (v, i) => {
        return (i < this.data.length-1) ? '#F0F0F0' : '#00587c'
      })
      let format = this.format
      let tooltip_label_fn = this.tooltip_label_fn

      let options = {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          xAxes: [{
            gridLines: {
              display: false,
            },
          }],
          yAxes: [{
            gridLines: {
              display: false,
              drawBorder: false,
            },
            ticks: {
              display: false,
            },
          }],
        },
        title: {
          display: false,
        },
        legend: {
          display: false
        },
        tooltips: {
          callbacks: {
            label: function(tooltipItem, data) {
              var label = data.datasets[tooltipItem.datasetIndex].label || ''
              if (tooltip_label_fn) label = tooltip_label_fn(tooltipItem.xLabel)
              if (label) label += ': '
              label += numeral(tooltipItem.yLabel).format(format)
              return label
            },
          },
        },
      }

      this.$refs.chart.renderChart({
        labels: this.labels,
        datasets: [
          {
            data: this.data,
            borderColor: '#00587c',
            borderWidth: 1,
            backgroundColor: backgroundColors,
            fill: this.type == 'bar',
            lineTension: 0,
            pointRadius: 0,
          },
        ]
      }, options)

    },
  },
  mounted() {
    this.render()
  }
}
</script>